import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { setError } from 'slices/subUserSlice';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { Controller, useForm } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { styled } from '@mui/material';
import { Dialog, DialogTitle } from '@mui/material';
import PhoneInput from 'components/common/PhoneInput';
import { Select } from 'components/common/Select';
import { fetchPermissionGroupList } from 'slices/permissionGroupSlice';
import { subUserSelector } from 'slices/subUserSlice';
import { updateSubUsers } from 'slices/subUserSlice';
import { addSubUsers } from 'slices/subUserSlice';
import { fetchSubUsers } from 'slices/subUserSlice';
const SubUsersForm = ({ item, handleClose, callback, show }) => {
  const dispatch = useDispatch();
  const { getValues, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm();
  const [status, setStatus] = useState(1)
  const { error, loader } = useSelector(subUserSelector);
  const clearAll = () => {
    setValue("name", '');
    // setValue("group_id", '');
    // setValue('type', '');
    setValue('gender', '');
    setValue('email', '');
    setValue('password', '');
    setValue('phone', '');
    setStatus(1)
    dispatch(setError({}))
  }
  const getCleanRole = (role) => {
    return role?.startsWith("staff_") ? role.replace("staff_", "") : role;
  };
  useEffect(() => {
    setValue('name', item?.user?.name || '');
    // setValue('group_id', item?.group?.id || '');
    // setValue('type', getCleanRole(item?.user?.role) || '');
    setValue('gender', item?.gender || '');
    setValue('email', item?.user?.email || '');
    setValue('phone', item?.phone || '');
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)
  }, [item]);

  useEffect(() => {
    return () => clearAll()
  }, [show])

  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchSubUsers())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    data = {
      ...data,
      status,
      group_id: 1,
    };
    if (item?.id) {
      dispatch(updateSubUsers(data, item?.id, submitCallback));
    } else
      dispatch(addSubUsers(data, submitCallback));

  }

  // #region Language dropdown
  const [groupSelect, setGroupSelect] = useState(null)

  useEffect(() => {
    setGroupSelect({
      label: item?.group?.name || "",
      value: item?.group?.id || ""
    });
  }, [item?.group]);


  const filterPermissionGroup = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchPermissionGroupList(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map(item => ({
        value: item.id,
        label: item.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  const GenderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Nonbinary", value: "nonbinary" }
  ];
  const typeOptions = [
    { value: 'agent', label: 'Agent' },
    { value: 'interpreter', label: 'Interpreter' },
    { value: 'remote_operator', label: 'Remote Operator' },
  ]


  const onError = (errors) => {
    console.log("errors", errors)

  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit, onError)}>

        <div className="row-primary">
          <h2>Sub User Name *</h2>
          <Controller
            name="name"
            rules={{
              required: "Please enter name"
            }}
            control={control}
            render={({ field }) =>
              <div className='w-100'>
                <input className="input-in type_inp" type="text" name='name' placeholder='Sub user name' {...field} />
                {errors?.name?.message && <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.name?.message} />
                </div>}
              </div>
            }
          />
        </div>

        {/* <div className="row-primary">
          <h2>Permission Group *</h2>
          <Controller
            name="group_id"
            required
            rules={{
              required: "Please select a group",
            }}
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement='auto'
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={groupSelect || null}
                    loadOptions={filterPermissionGroup}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setGroupSelect(selected);
                      field.onChange(selected ? selected.value : null);
                    }}

                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.group_id?.message && <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.group_id?.message} />
                </div>}
              </div>
            }
          />
        </div> */}

        <div className="row-primary">
          <h2>Gender *</h2>
          <Controller
            name="gender"
            control={control}
            rules={{
              required: "Please select a gender"
            }}
            render={({ field }) => (
              <div className='select_box' style={{ width: "100%" }}>
                <Select
                  name="gender"
                  options={GenderOptions}
                  value={GenderOptions.find(opt => opt.value === field.value) || ""}
                  isClearable={false}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                />
                {errors?.gender?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.gender?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        <div className="row-primary">
          <h2>Email *</h2>
          <Controller
            name="email"
            rules={{
              required: 'Email field is required'
            }}
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <input className="input-in type_inp" type="email" name='email' placeholder='Email address' {...field} />
                {errors?.email?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.email?.message} />
                  </div>
                )}
                {
                  error?.errors?.email?.length > 0 &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={error?.errors?.email?.[0]} />
                  </div>
                }
              </div>
            )
            }
          />
        </div>

        <div className="row-primary">
          <h2>Password {item ? '' : '*'}</h2>
          <div className="w-100">
            <Controller
              name="password"
              control={control}
              rules={
                item ? {} : {
                  required: "Password required",
                }
              }
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="password"
                  placeholder="Password"
                  {...field}
                />
              )}
            />
            {errors?.password?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.password?.message} />
              </div>
            )}
          </div>
        </div>


        <div className="row-primary">
          <h2>Phone *</h2>
          <div className="w-100">
            <Controller
              name="phone"
              rules={{
                required: "Please enter phone",
              }}
              control={control}
              render={({ field }) => <PhoneInput className="input-in type_inp" type="tel" name='phone' placeholder='Phone number' {...field} />}
            />
            {
              errors?.phone?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.phone?.message} />
              </div>
            }
          </div>
        </div>

        <div className="row-primary align-items-ceneter">
          <h2 className='mt-0'>Status</h2>
          <CustomSwitch
            labelText="active"
            checked={status == 1 ? true : false}
            handleChange={(checked) => setStatus(checked ? 1 : 0)}
          />
        </div>

        {error?.errors?.name?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" onClick={handleClose} >Cancel</button>
          <SubmitButton
            btnText={item?.id ? "Update" : "Create"}
            loader={loader}
          />
        </div>
      </form>

    </div>
  )
}

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-container': {
    overflowY: "auto",
    margin: "auto",
    alignItems: "flex-start",
  },
  '& .MuiPaper-root': {
    maxHeight: "none",
    overflowY: "hidden",
    borderRadius: 20
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    backgroundColor: "red"
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    backgroundColor: "red"
  },
}));

const AddSubUsers = ({ item, onClose, callback, show }) => {

  return (
    <>

      <BootstrapDialog
        fullWidth={true}
        maxWidth={"md"}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={show}
        sx={{
          '& .MuiDialog-container': {
            alignItems: "center",
          },
          '& .MuiPaper-root': {
            overflowY: "visible",

          },
        }}
      >
        <div className="">
          <div className="modal-content full_modal">
            <DialogTitle>
              <div className="modal-header header_modal align-items-center">
                <div></div>
                <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Sub Users</h5>
                <button type="button" className="btn-close"
                  aria-label="Close"
                  onClick={
                    () => {
                      onClose(item?.id, item?.status);
                    }
                  }></button>
              </div>
            </DialogTitle>
            <div className="modal-body modal_form_body">
              <SubUsersForm item={item} handleClose={onClose} callback={callback} show={show} />
            </div>
          </div>
        </div>
      </BootstrapDialog>
    </>
  )
}

export default AddSubUsers
